import React from 'react'

import { ActionsRefProvider } from '../CardActionRefContext'
import type { CardBlockElements, CardRadioItemProps } from '../interfaces'

import { CardRadioBase } from './CardRadioItemBase'

export const CardRadioItem = <T extends CardBlockElements = 'div'>(
  props: CardRadioItemProps<T>,
) => {
  return (
    <ActionsRefProvider>
      <CardRadioBase {...props} />
    </ActionsRefProvider>
  )
}
